import { Link } from "react-router-dom";

const EventAddtoCart = () => {
   return(
    <>
        <div className="box-wishlist">
            <div className="link-Rottaion">
                <Link to="/checkout/cart"> 
                    <i className="bi bi-cart-check-fill"></i>
                    <div className="badge-danger"> 0 </div>
                </Link>
            </div>
        </div>
    </>
   )
}
export default EventAddtoCart;